var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-placeholder",class:{ small: _vm.small }},[_c('div',{staticClass:"circle-responsive"},[_c('p',{staticClass:"circle-text",class:{ small: _vm.small }},[_vm._v(" "+_vm._s(_vm.initialsName)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }